import VueElementLoading from 'vue-element-loading';
export default {
  name: 'loader',
  components: {
    VueElementLoading
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
     //isLoading:false
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/loader/loader.component.js